import React from 'react';
import { Button, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ValidateIcon } from 'components/Icons';
import { colors } from 'theme';
import Dialog from 'components/Dialog';
import { DialogWidth } from 'types';

const useStyles = makeStyles({
  titleContainer: {
    width: '100%',
  },
  warningIcon: {
    width: '10%',
    color: colors.darkOrange,
    margin: '0px 13px 0px 18px',
  },
  title: {
    fontSize: '24px',
    lineHeight: '30px',
    fontWeight: 600,
    textAlign: 'left',
    paddingLeft: '18px',
  },
  message: {
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'left',
    paddingLeft: '18px',
    fontWeight: 400,
  },
  messageAlert: {
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'left',
    paddingLeft: '18px',
    color: '#FF9F0A',
    fontWeight: 400,
  },
  buttonLine: {
    display: 'flex',
    marginTop: '25px',
    marginBottom: '15px',
    justifyContent: 'flex-end',
    width: '100%',
  },
  button: {
    padding: '10px',
    margin: '0 10px',
    width: 148,
    height: 38,
    textTransform: 'uppercase',
  },
  validateButton: {
    color: 'white',
    backgroundColor: '#2F3741',
  },
  icon: {
    fontSize: '100px',
    fontWeight: 600,
    margin: '6px',
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  closeIcon: {
    width: '16px',
  },
});

type ReopenMultiModalProps = {
  isOpen: boolean;
  monthInMessage: string;
  yearOfNextClosureClosed: number;
  closureToReopenYear: number;
  onClose: () => void;
  onValidate: () => void;
};

export const ReopenMultiModal: React.FC<ReopenMultiModalProps> = ({
  isOpen,
  monthInMessage,
  onClose,
  onValidate,
  closureToReopenYear,
  yearOfNextClosureClosed,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog
      closable={true}
      renderButton={() => {}}
      isOpen={isOpen}
      onClose={onClose}
      width={DialogWidth.LARGE_FORM}
      title={''}
      renderContent={() => (
        <>
          <div className={classes.titleContainer}>
            <Typography className={classes.title}>
              {t('closures.reopen.modal.title', { year: closureToReopenYear, month: monthInMessage })}
            </Typography>
            <br />
            <Typography className={classes.message}>
              {t('closures.reopen.modal.message', { month: monthInMessage })}
            </Typography>
            <br />
            <Typography className={classes.message}>{t('closures.reopen.modal.messageWarning')}</Typography>
            {yearOfNextClosureClosed !== closureToReopenYear && (
              <>
                <br />
                <Typography className={classes.messageAlert}>
                  {t('closures.reopen.modal.alert', { year: closureToReopenYear })}
                </Typography>
              </>
            )}
          </div>

          <div className={classes.buttonLine}>
            <div className={classes.buttonContainer}>
              <Button variant="outlined" className={classes.button} onClick={onClose}>
                {t('cancel')}
              </Button>
              <Button
                variant="outlined"
                type="submit"
                data-qa-id={t('closures.reopen.buttonLabel')}
                className={classNames(classes.button, classes.validateButton)}
                onClick={onValidate}
              >
                {t('closures.reopen.buttonLabel')}
                <ValidateIcon className={classes.icon} />
              </Button>
            </div>
          </div>
        </>
      )}
    />
  );
};

export default ReopenMultiModal;
